import { mvUUID } from '../../helpers/MvUUID'
import { sha256HashString } from '../../helpers/hash'
import Logger from '../../helpers/Logger'
import type WebModel from '../../models/WebModel'

export function removePPID(model: WebModel): void {
  // simple function to tell Google to remove PublisherProvidedID (PPID)
  if (mvUUID.id) {
    const hashedMvUUIDPromise = sha256HashString(mvUUID.id)
    hashedMvUUIDPromise.then((hashedMvUUID) => {
      const url = `https://securepubads.g.doubleclick.net/user_data_deletion?ppid=${hashedMvUUID}&iu=${model.offering.gam_network_code}`
      fetch(url, {
        method: 'GET'
      })
        .then((res) => {
          // noop
          //  res.ok PPID was found and deleted
          //  !res.ok who knows.  PPID not found || ???
        })
        .catch((err) => {
          // only when there is an error such as wrong method type
          Logger.debug({ name: err.name, message: err.message })
        })
    })
  }
}
